<template>
    <div class="search_block">
        <div class="">
            <div class="col-sm-5 col-xs-12 nopadding">
                <input type="text"
                       class="form-control main-enter"
                       id="company-video"
                       name="company"
                       autocomplete="off"
                       :placeholder="keyword_placeholder_trans"
                       v-model="selected_keyword"
                       @blur="closeMenu"
                       ref="keyword_input"
                       @click="keywords_loading = true; openMenu(); getKeywordAutoComplete()"
                       @keyup.enter="makeSearch"
                       @keyup="keywords_loading = true; getKeywordAutoComplete()"
                >

                <div class="col-md-12 search_results resp_absolute" v-if="menu_open" style="z-index: 99;">
                    <div v-if="keywords_loading" class="text-center">
                        <img src="/assets/img/ball-triangle.svg" class="svg-loader" alt="Loading"/>
                    </div>
                    <div v-else-if="!keywords_loading && show_suggestions && suggested_searches.length > 0">
                        <div class="col-md-12 separator_text">
                            <h4 class="ui horizontal divider header">
                                {{ suggested_searches_trans }}
                            </h4>
                        </div>

                        <div class="col-md-4 col-sm-6 col-xs-6 suggested_search_holder"
                             v-for="suggested_search in suggested_searches"
                             @click="setKeyword(suggested_search.name)">
                            <div class="suggested_search" @click="setKeyword(suggested_search.name)">
                                <span :title="suggested_search.name">{{ suggested_search.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="!keywords_loading && keywords.length > 0">
                        <div class="row single_search_result" v-for="keyword in keywords"
                             @click="setKeyword(keyword); ">
                            {{ keyword }}
                        </div>
                    </div>
                    <div v-else-if="!keywords_loading">
                        <h5 class="text-center no_results_message">{{ no_suggestions_trans }}</h5>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 col-xs-12 nopadding" style="border-left: 1px solid #cccccc;">
                <div class="relative">
                    <HereAddressLookup
                        @address="getAddressData"
                        @searching-location="setLoading"
                        id="homeSearch"
                        :placeholder="city_placeholder_trans"
                        :app_key="here_maps_key"
                        :city-not-selected="cityNotSelected"
                        ref="vuegoogle"/>
                    <div class="absolute current-location" @click="getCurrentLocation" title="Current location"></div>
                </div>
            </div>

            <div class="col-sm-3 nopadding">
                <button class="btn btn-primary" style="width: 100%"
                        type="button"
                        @click="makeSearch"
                        :disabled="loading">
                    <div v-if="loading" class="spinner"></div>
                    <div v-else><i class="lnr lnr-magnifier"></i> {{ button_trans }}</div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import search from '../search';
import HereAddressLookup from '../components/HereAddressLookup.vue';

export default {
    mixins: [
        search
    ],

    components: {
        HereAddressLookup
    },

    props: {
        button_trans: {
            type: String,
            default: 'Search'
        },
        not_location_selected: {
            type: String,
            default: 'Please select a location'
        },
        keyword_placeholder_trans: {
            type: String,
            default: 'Search'
        },
        city_placeholder_trans: {
            type: String,
            default: 'City'
        },
        suggested_searches_trans: {
            type: String,
            default: 'Suggested Searches'
        },
        no_suggestions_trans: {
            type: String,
            default: 'No suggestions'
        },
        auto_complete_route: {
            type: String,
            required: true
        },
        build_search_route: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            address: {},
            keywords: false,
            selected_keyword: '',
            suggested_searches: [],
            delay: 250,
            menu_open: false,
            show_suggestions: true,
            keywords_loading: true,
            placeResultData: '',
            scripts_loaded: false,
            loading: false,
            here_maps_key: '',
            cityNotSelected: false,
        }
    },

    watch: {
        selected_keyword() {
            this.show_suggestions = !this.selected_keyword.length
        }
    },

    methods: {
        setLoading(payload) {
            this.loading = payload;
        },
        makeSearch() {
            let VueInstance = this;

            this.loading = true;

            if (!VueInstance.address.locality && VueInstance.address.locality !== undefined) {
                VueInstance.address['locality'] = VueInstance.placeResultData.name;
            }

            if (! VueInstance.address.locality && ! VueInstance.selected_keyword.length) {
                VueInstance.loading = false;

                window.location.href = '/restaurants';

                return;
            }

            if (VueInstance.address.locality && (VueInstance.address.locality || VueInstance.selected_keyword.length)) {
                let search_obj = {
                    'company_search': VueInstance.selected_keyword,
                    'search_city': VueInstance.address,
                    'search_terms': []
                };

                this.suggested_searches.forEach(function (terms) {
                    if (terms.name === VueInstance.selected_keyword) {
                        search_obj.search_terms.push(terms.slug);
                        search_obj.company_search = '';
                    }
                });

                axios.post(VueInstance.build_search_route, search_obj)
                    .then(function (response) {
                        VueInstance.loading = false;

                        if (response.data.status === 'success') {
                            window.location.href = response.data.url;
                        } else if (response.data.status === 'not_supported') {
                            iziToast.show({
                                title: response.data.message,
                                color: response.data.code  // blue, red, green, yellow
                            });
                        }
                    })
                    .catch(function (error) {
                        VueInstance.loading = false;
                        console.log(error);
                    });
            } else {
                this.cityNotSelected = true;
                this.loading = false;

                iziToast.show({
                    title: this.not_location_selected,
                    color: 'red' // blue, red, green, yellow
                });
            }
        },
        getAddressData: function (addressData, placeResultData) {
            this.address = addressData;
            this.placeResultData = placeResultData;
            this.cityNotSelected = false;
        },
        openMenu() {
            this.menu_open = true;
        },
        closeMenu() {
            let VueInstance = this;
            setTimeout(function () {
                VueInstance.menu_open = false;
            }, 100);
        },
        setKeyword(keyword) {
            this.closeMenu();
            this.selected_keyword = keyword;
            this.$refs.keyword_input.focus();
        },
        getKeywordAutoComplete() {
            let self = this;

            let requestedType = 'keywords';

            if (! self.selected_keyword) {
                requestedType = 'categories';
            }

            if (!self.selected_keyword && self.suggested_searches.length > 0) {
                self.keywords_loading = false;
                return;
            }

            axios.get(`${self.auto_complete_route}?search_query=${self.selected_keyword}&requested_type=${requestedType}`)
                .then(function (response) {

                    if (requestedType === 'keywords') {
                        self.keywords = response.data.results;
                    } else if(requestedType === 'categories') {
                        self.suggested_searches = response.data.results;
                    }

                    self.keywords_loading = false;
                })
                .catch(function (error) {
                    self.keywords_loading = false;
                });
        },
        getCurrentLocation() {
            if (this.address.locality !== undefined) {
                $('#homeSearch').val(this.address.locality);
                return;
            }

            let _this = this;

            if (navigator.geolocation) {
                if (!this.scripts_loaded) {
                    this.loadMapScripts();
                    this.scripts_loaded = true;
                }

                setTimeout(async () => {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        let platform = new H.service.Platform({
                            'apikey': _this.here_maps_key
                        });
                        let geocoder = platform.getGeocodingService();
                        let latlng = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };

                        geocoder.reverseGeocode(
                            {
                                mode: "retrieveAddresses",
                                maxresults: 1,
                                prox: latlng.lat + "," + latlng.lng
                            }, data => {
                                if (data.Response.View[0]['Result'][0]['Location']['Address']['City'] !== undefined) {
                                    let city = data.Response.View[0]['Result'][0]['Location']['Address']['City'];

                                    _this.address = {
                                        'locality': city,
                                        'latitude': position.coords.latitude,
                                        'longitude': position.coords.longitude
                                    };

                                    $('#homeSearch').val(city);
                                }
                            }, error => {
                                console.error(error);
                            }
                        );

                    }, function (error) {
                        alert("Unable to retrieve your location");
                        console.log(error);
                    });
                }, 500);
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        },
        loadMapScripts() {
            let _this = this;

            const {main, service} = JSON.parse(window.hereMapsScript);

            this.loadScript(main, function () {
                _this.loadScript(service);
            });
        },
        loadScript(url, callback) {
            let head = document.head;
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;

            if (callback) {
                script.onreadystatechange = callback;
                script.onload = callback;
            }

            head.appendChild(script);
        }
    },

    created() {
        this.getKeywordAutoComplete = debounce(this.getKeywordAutoComplete, this.delay);
    },

    mounted() {
        this.here_maps_key = window.hereMapsRestKey;
    },
}
</script>

<style>
.suggested_search {
    height: 25px;
    padding: 0 5px;
    display: flex;
    align-items: center;
    background: rgba(189, 189, 189, 0.13);
    color: #696969;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
}

.suggested_search span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.suggested_search:hover {
    background: rgba(130, 130, 130, 0.15);
    cursor: pointer;
}

.suggested_search_holder {
    margin-bottom: 10px;
}

.suggested_search_holder:last-child {
    margin-bottom: 20px;
}

.search_results {
    background: #ffffff;
    border: 1px solid #e9e9e9;
    border-top-width: 0;
    position: absolute;
}

.separator_text {
    margin-bottom: 10px;
    margin-top: 10px;
}

.single_search_result {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 8px 15px;
}

.single_search_result:hover {
    background: rgba(130, 130, 130, 0.15);
    cursor: pointer;
}

.no_results_message {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
}

.svg-loader {
    width: 50px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.current-location {
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    background-image: url(~/images/flaticons/aim.svg);
    cursor: pointer;
}

.main-enter::-ms-clear,
.main-enter::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
}

.btn[disabled] {
    opacity: 1;
}

@media (max-width: 767px) {
    .nopadding {
        position: inherit !important;
    }

    .resp_absolute {
        left: 15px;
        right: 15px;
    }
}
.has-error .form-control {
    border: 2px solid #a94442;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HomeSearch.vue